'use client';

import { useQuery } from '@tanstack/react-query';

import { StripeAccountStatus, getStripeAccountStatus } from '@website/services/stripe.service';

export function useStripeAccountStatus(professionalId: string | undefined) {
  return useQuery<StripeAccountStatus>({
    queryKey: ['stripeAccountStatus', professionalId],
    queryFn: () => getStripeAccountStatus(professionalId!),
    enabled: !!professionalId,
    staleTime: 30 * 1000, // 30 seconds
    retry: 2
  });
}
